import angular from "angular";
import { EditCtrl } from "../Editor";
import OpravnenaOsobaEditCtrl from "./OpravnenaOsobaEditCtrl";
import OdberneMiestoService from "./OdberneMiestoService";
import OdberneMiestoImportCtrl from "./OdberneMiestoImportCtrl";
import OdberneMiestoListCtrl from "./OdberneMiestoListCtrl";
import OdberneMiestoOpravnenaOsobaListCtrl from "./OdberneMiestoOpravnenaOsobaListCtrl";
import OdberneMiestoOpravnenaOsobaService from "./OdberneMiestoOpravnenaOsobaService";
import OdberneMiestoEditCtrl from "./OdberneMiestoEditCtrl";


export default angular
.module("energis.odbernemiesto", [])
.config(function routes($stateProvider){
  $stateProvider
  .state("odbernemiesto-list", {
    url: "/odberne-miesta",
    template: require("./odbernemiesto.list.html"),
    controller: OdberneMiestoListCtrl,
    controllerAs: "ctrl",
    resolve: {
      itemSource: OdberneMiestoService => OdberneMiestoService.listSource().wait()
    }
  })
  .state("odbernemiesto-edit", {
    url: "/odberne-miesta/{id:int}/edit",
    template: require("./odbernemiestoote.edit.html"),
    controller: OdberneMiestoEditCtrl,
    controllerAs: "ctrl",
    resolve: {
      item: ($stateParams, OdberneMiestoService) => OdberneMiestoService.get($stateParams.id),
      saveHandler: (OdberneMiestoService) => (id, item) => OdberneMiestoService.saveItem(id, item),
      opmStatuses: (OdberneMiestoService) => OdberneMiestoService.getOpmStatuses(),
    }
  })
  .state("odbernemiesto-create", {
    url: "/odberne-miesta/create/{kontaktId:int}",
    template: require("./odbernemiesto.edit.html"),
    controller: EditCtrl,
    controllerAs: "ctrl",
    resolve: {
      item: ($stateParams, OdberneMiestoService) => OdberneMiestoService.create($stateParams.kontaktId),
      saveHandler: (OdberneMiestoService) => (id, item) => OdberneMiestoService.save(id, item),
    }
  })
  .state("odbernemiesto-import", {
    url: "/odberne-miesta/import",
    template: require("./odbernemiesto.import.html"),
    controller: OdberneMiestoImportCtrl,
    controllerAs: "ctrl",
  })
  .state("odbernemiesto-opravnena-osoba-list", {
    url: "/opravnena-osoba",
    template: require("./odbernemiesto.opravnena.osoba.list.html"),
    controller: OdberneMiestoOpravnenaOsobaListCtrl,
    controllerAs: "ctrl",
    resolve: {
      itemOpravnenaOsoba: OdberneMiestoService => OdberneMiestoService.listOpravnenaOsoba().wait()
    }
  })
  .state("odbernemiesto-opravnena-osoba-edit", {
    url: "/opravnena-osoba/{id:int}/edit",
    template: require("./odbernemiesto.opravnena.osoba.edit.html"),
    controller: OpravnenaOsobaEditCtrl,
    controllerAs: "ctrl",
    resolve: {
      item: ($stateParams, OdberneMiestoOpravnenaOsobaService) => OdberneMiestoOpravnenaOsobaService.get($stateParams.id),
      saveHandler: (OdberneMiestoOpravnenaOsobaService) => (id, item) => OdberneMiestoOpravnenaOsobaService.save(id, item),
      urovenOpravenenia: (OdberneMiestoOpravnenaOsobaService) => OdberneMiestoOpravnenaOsobaService.getUrovneOpravnenia(),
      getOdberneMiestoOteCheck: (OdberneMiestoOpravnenaOsobaService) => (item) => OdberneMiestoOpravnenaOsobaService.getOdberneMiestoOteCheck(item),
    },
   // redirectTo: 'odbernemiesto-opravnena-osoba-list'
  })

})
.service("OdberneMiestoService", OdberneMiestoService)
.service("OdberneMiestoOpravnenaOsobaService", OdberneMiestoOpravnenaOsobaService)
.name;



// WEBPACK FOOTER //
// ./src/OdberneMiesto/index.js